/*jslint browser: true, todo: true, -W117, sloppy: true */
import { SimpleDialog } from 'global/simple-dialog.src';

/*------------------------------------*\
    SIMPLE DIALOG
\*------------------------------------*/
$(function () {
    if ($('.js-preview-link').length) {
        var dialog = new SimpleDialog(document.getElementById('cover_preview'));
        var dialogImgUrl = $('.js-image-preview');
        $('.js-preview-link').on('click', function (e) {
            e.preventDefault();
            var imageUrl = $(this).attr('href');
            dialogImgUrl.attr('src', imageUrl);
            dialog.show();
        });
    }
});

/*------------------------------------*\
    GET ELEMENTS HEIGHT
\*------------------------------------*/
var navHeight;

function resizeContent() {
    navHeight = $('.rheader').eq(0).outerHeight();
}
$(document).ready(function () {
    resizeContent();
    $(window).resize(function () {
        resizeContent();
    });
});

/*------------------------------------*\
    SUB-CATEGORY
\*------------------------------------*/
$(document).ready(function () {
    var menu = $('.change-category'),
        trigger = $('.change-category .cnt a').eq(0);

    // show hide menu for mobile devices
    function toggleMenu() {
        menu.toggleClass('open');
    }
    //hide menu for mobile devices
    function closeMenu() {
        menu.removeClass('open');
    }

    trigger.on('click', function (e) {
        e.preventDefault();
        toggleMenu();
    });
    $('.change-category').on('click', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', function () {
        closeMenu();
    });
});

/*------------------------------------*\
    SHOW/HIDE CATEGORY
\*------------------------------------*/
$(document).ready(function () {
    var category = $('.templates-category .category');

    var moretext = $.register.translate.readmore,
        lesstext = $.register.translate.readless;

    category.each(function () {
        $(this)
            .find('.trigger')
            .click(function () {
                var topTrigger = $(this).parents('.category').find('.trigger').eq(0);
                topTrigger.hide();

                $(this).parents('.category').find('.show-more').fadeToggle(600);

                // Shortened Text With “Show More” Link
                if (topTrigger.hasClass('less')) {
                    topTrigger.removeClass('less');
                    topTrigger.find('span').html(moretext);
                } else {
                    topTrigger.addClass('less');
                    topTrigger.find('span').html(lesstext);
                }
                return false;
            });

        $(this)
            .find('.show-more .trigger')
            .click(function () {
                var topTrigger = $(this).parents('.category').find('.trigger').eq(0);
                topTrigger.show();
                $('html, body').animate(
                    {
                        /*scrollTop: $(this).parents('.category').offset().top - navHeight*/
                        scrollTop: 0,
                    },
                    600,
                );
            });
    });
});
